<template>
  <div class="table-btn-group">
<!--    v-if="!checkPermissionBtn(item.code)"-->
    <!--      v-permission="[item.code]"-->
    <a-button
      class="tablebtn"
      v-for="item in tableBtnArr"
      v-permission="[item.code]"
      :key="`${item.id}-${item.name}`"
      :type="item.type"
      @click="handleEvent2(item.method)"
    >
      {{ item.name }}
    </a-button>
  </div>
</template>

<script>
export default {
  name: "table-btn-group",
  props: {
    tableBtnArr: {
      type: Array, //指定变量接受的类型
      default: [],
      required: true //required为true表示必须传递一个值给此变量
    }
  },

  data() {
    return {};
  },
  mounted() {
    console.log(this.tableBtnArr,'kkkkkkkk');
  },
  methods: {
    handleEvent2(method) {
      this.$emit("handleEvent", method);
    }
  }
};
</script>

<style scoped>
.table-btn-group {
  text-align: left;
}
.tablebtn {
  margin-right: 8px;
}
/*.ant-btn {*/

/*}*/
/*&:not(:last-child) {*/
/*   margin-right: 8px;*/
/* }*/
</style>



// WEBPACK FOOTER //
// src/components/TableBtnGroup.vue